import { testimonials } from "@/mocks/anime";

const values = [
  { icon: "ri-heart-line", title: "热爱内容", desc: "只收录真正值得看的番，分类清晰，找番不迷路。" },
  { icon: "ri-focus-3-line", title: "专注体验", desc: "把免费高清、无广告与流畅放到第一位，追番不打断。" },
  { icon: "ri-hand-heart-line", title: "一路同行", desc: "与观众共同成长，让每一次连续补番都成为美好记忆。" },
];

export default function About() {
  return (
    <section id="about" className="section-pad">
      <div className="container-site">
        <div className="grid gap-10 lg:grid-cols-2 lg:items-center">
          <div>
            <span className="text-xs font-medium uppercase tracking-widest text-accent-600">About Us</span>
            <h2 className="mt-1 font-heading text-3xl md:text-4xl">关于漫途动漫</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              漫途动漫是一个专注于卡通动漫综合免费看的在线追番平台。我们深知补番党最大的痛点——
              不是找不到番，而是被广告打断、被卡顿劝退。因此，我们把「高清无广告 + 流畅连播」当作立站之本，
              让你从第一集到最后一集，一气呵成、畅快开刷。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              我们坚持全网搜罗优质片源，覆盖热血、恋爱、奇幻、科幻、搞笑、运动、悬疑、萌系等全类型，
              支持全集收录与一口气连播模式，满足不同口味的追番需求。
            </p>

            <div className="mt-7 grid gap-4 sm:grid-cols-3">
              {values.map((v) => (
                <div key={v.title} className="rounded-2xl border border-background-200 bg-background-100 p-4">
                  <span className="grid h-11 w-11 items-center justify-center rounded-xl bg-primary-100 text-xl text-primary-700">
                    <i className={v.icon} />
                  </span>
                  <h3 className="mt-3 font-heading text-base text-foreground-950">{v.title}</h3>
                  <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{v.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="rounded-3xl border border-background-200 bg-gradient-to-br from-background-100 to-background-50 p-6 md:p-8">
            <div className="flex items-center justify-between">
              <h3 className="font-heading text-xl text-foreground-950">用户口碑</h3>
              <span className="flex items-center gap-1 text-sm font-medium text-secondary-600">
                <i className="ri-star-fill text-secondary-500" />
                4.9 / 5.0
              </span>
            </div>
            <div className="mt-5 flex flex-col gap-4">
              {testimonials.map((t) => (
                <figure
                  key={t.name}
                  className="rounded-2xl border border-background-200 bg-background-50 p-5"
                >
                  <div className="flex items-center gap-3">
                    <img
                      src={t.avatar}
                      alt={`${t.name} 的用户头像`}
                      className="h-11 w-11 rounded-full object-cover"
                    />
                    <div>
                      <figcaption className="font-heading text-sm text-foreground-950">{t.name}</figcaption>
                      <span className="text-xs text-foreground-500">{t.role}</span>
                    </div>
                    <span className="ml-auto rounded-full bg-accent-100 px-2.5 py-1 text-[11px] text-accent-700">
                      {t.tag}
                    </span>
                  </div>
                  <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">“{t.text}”</blockquote>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}